import React, { useEffect, useState, useRef } from "react";
import { SelectInput, TextInput } from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal";
import {
  logReportAction,
  masterActions,
  inmateAction,
  authActions,
} from "../../_store";
import { useDispatch, useSelector } from "react-redux";
import activeIcon from "../../assets/svg/active-user.svg";
import inactiveIcon from "../../assets/svg/inactive-user.svg";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import { Page } from "react-pdf";
import generateXlsx from "../../components/common/export/generateXlsx";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";
import { fDate1, getCurrentDate, fDate, formatDateTimeAMPM } from "../../utils/formatTime";
import { history } from "../../_helpers";
import CustomLoader from "../../components/common/ui/Loader";

function InmateAccessableMenus() {
  const { facilityDropDown, inmateAccessMenuList } = useSelector(
    (x) => x.master
  );

  const {
    InmateAccessMenus,
    inmateAccessReportList,
    inmateAccessibleMenuList,
    inmateAccessReportFullList,
  } = useSelector((x) => x.logReport);

  const { podStatusOptions } = useSelector((x) => x.dropdownOptions);
  const [showSearchFields, setShowSearchFields] = useState(false);

  let InmateAccessMenuSearch = { ...InmateAccessMenus };
  const dispatch = useDispatch();

  //Load Facility dropdown
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 })
    );
  }, [dispatch]);
  useEffect(() => {
    handleReset();
  }, []);

  //Load Inmate Accessible Menu
  useEffect(() => {
    if (InmateAccessMenuSearch.FacilityID) {
      dispatch(
        masterActions.GetInmateMenuList(InmateAccessMenuSearch.FacilityID)
      );
    }
  }, [InmateAccessMenuSearch.FacilityID]);
  // const [InmateAccessMenuSearch, setInmateAccessMenuSearch] = useState({
  //   FacilityID: null,
  //   InmateResidentID: "",
  //   InmateMenuAccessReports: [],
  //   InmateStatus: 1,
  //   PageNo: 1,
  //   RowCountPerPage: 10,
  //   SortField: "",

  // });

  // //Load Inmate Accessible Menu when the PageNo and RowCountPerPage changes
  useEffect(() => {
    dispatch(logReportAction.InmateAccessReport(InmateAccessMenuSearch));
  }, [InmateAccessMenuSearch?.PageNo, InmateAccessMenuSearch?.RowCountPerPage]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    InmateAccessMenuSearch.InmateResidentID = value.replace(/\D/g, "");

    dispatch(logReportAction.setInmateMenu(InmateAccessMenuSearch));
  };
  const handleSelectChange = (selectedOptions, name) => {
    // Helper function to process Accessible Menu options
    const handleAccessibleMenu = () => {
      if (Array.isArray(selectedOptions)) {
        InmateAccessMenuSearch.InmateMenuAccessReports = selectedOptions.map(
          (option) => ({
            InmateMenuID: option?.value,
            MenuName: option?.label,
            // value: option.value,
            // label: option.label,
          })
        );
      } else {
        // Clear data when no options are selected
        InmateAccessMenuSearch.InmateMenuAccessReports = [];
      }
    };

    const loadGrid = () => {
      if (
        InmateAccessMenuSearch?.FacilityID &&
        InmateAccessMenuSearch?.InmateMenuAccessReports.length > 0
      ) {
        dispatch(
          logReportAction.InmateAccessReport({
            ...InmateAccessMenuSearch,
            PageNo: 1,
            RowCountPerPage: 10,
          })
        );
        //dispatch(logReportAction.InmateAccessReport(InmateAccessMenuSearch));
      } else {
        // Popup({
        //   title: "Message",
        //   text: `Choose any one of the FacilityCode in dropdown list`,
        //   icon: "info",
        //   confirmButtonText: "Ok",
        // });
      }
    };

    switch (name) {
      case "FacilityID":
        if (
          selectedOptions?.value !== null &&
          selectedOptions?.value !== undefined &&
          selectedOptions?.value !== 0
        ) {
          Popup({
            title: "Message",
            text: `Select any one of the Accessible Menu in the dropdown list`,
            icon: "info",
            confirmButtonText: "Ok",
          });
        }

        InmateAccessMenuSearch[name] = selectedOptions?.value || 0;
        InmateAccessMenuSearch.InmateMenuAccessReports = [];
        dispatch(logReportAction?.clearinmateAccessReportList());
        break;
      case "Accessible Menu":
        handleAccessibleMenu();
        // InmateAccessMenuSearch.InmateMenuAccessReports = [];
        break;
      // InmateStatus
      case "InmateStatus":
        InmateAccessMenuSearch[name] =
          selectedOptions?.value === 0 ? 0 : selectedOptions?.value || 1;

        loadGrid();
        break;
      default:
        break;
    }
    dispatch(
      logReportAction.setInmateMenu({
        ...InmateAccessMenuSearch,
        PageNo: 1,
        RowCountPerPage: 10,
      })
    );
  };

  // const previousFacilityID = useRef(InmateAccessMenuSearch?.FacilityID);

  // const handleSelectChange = (selectedOption, name) => {
  //   setInmateAccessMenuSearch((prev) => {
  //     let updatedState = { ...prev };

  //     if (name === "FacilityID") {
  //       const newFacilityID = selectedOption?.value || null;
  //       updatedState.FacilityID = newFacilityID;

  //       // Always clear accessible menu on facility change
  //       updatedState.InmateMenuAccessReports = [];

  //       // Check if it's a "clear/reset" (selectedOption is null when cleared)
  //       const isCleared = selectedOption === null;

  //       if (!isCleared && previousFacilityID.current !== newFacilityID) {
  //         // Only show popup if it's a real change (not reset/clear)
  //         Popup({
  //           title: "Message",
  //           text: `Choose any one of the Accessible Menu in the dropdown list`,
  //           icon: "info",
  //           confirmButtonText: "Ok",
  //         });
  //       }

  //       // Update previousFacilityID for future comparison
  //       previousFacilityID.current = newFacilityID;
  //     }

  //     dispatch(logReportAction.setInmateMenu(updatedState));
  //     return updatedState;
  //   });
  // };

  const handleSearch = (e) => {
    e.preventDefault();
    if (
      InmateAccessMenuSearch.FacilityID &&
      InmateAccessMenuSearch.InmateMenuAccessReports.length > 0
    ) {
      dispatch(
        logReportAction.InmateAccessReport({
          ...InmateAccessMenuSearch,
          PageNo: 1,
          RowCountPerPage: 10,
        })
      );
      dispatch(
        logReportAction.setInmateMenu({
          ...InmateAccessMenuSearch,
          PageNo: 1,
          RowCountPerPage: 10,
        })
      );
    } else if (!InmateAccessMenuSearch.FacilityID) {
      dispatch(logReportAction.clearinmateAccessReportList());
      Popup({
        title: "Message",
        text: `Select any one of the Facility Code in the dropdown list`,
        icon: "info",
        confirmButtonText: "Ok",
      });
    } else if (
      InmateAccessMenuSearch.FacilityID > 0 ||
      InmateAccessMenuSearch.InmateMenuAccessReports.length === 0
    ) {
      dispatch(logReportAction.clearinmateAccessReportList());
      Popup({
        title: "Message",
        text: `Select any one of the Accessible Menu in the dropdown list`,
        icon: "info",
        confirmButtonText: "Ok",
      });
    }
    //  dispatch(logReportAction.InmateAccessReport(InmateAccessMenuSearch));
  };

  const handleReset = () => {
    dispatch(logReportAction.clearInmateMenu());
    dispatch(masterActions.clearinmateAccessMenuList());
    // setInmateAccessMenuSearch((prev)=>
    // ({
    //   ...prev,
    //   InmateMenuAccessReports:[]
    // })
    // )
  };

  //Table

  const column = [
    {
      name: "ID",
      key: "InmateResidentId",
      selector: (row) => row.InmateResidentID,
      cell: (row) => (
        <div
          className="Common_Link_Style"
          onClick={() => handleNavigateInmateInfoID(row)}
        >
          {row.InmateResidentID}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Last Name",
      key: "LastName",
      selector: (row) => row.LastName,
      sortable: true,
    },
    {
      name: "First Name",
      key: "FirstName",
      selector: (row) => row.FirstName,
      sortable: true,
    },
    {
      name: "POD",
      key: "PodCode",
      selector: (row) => row.PodCode,
      sortable: true,
    },
    {
      name: "Gender",
      key: "Gender",
      selector: (row) => row.Gender,
      sortable: true,
    },
    {
      name: "DOB",
      key: "DOB",
      selector: (row) => fDate(row.DOB),
      sortable: true,
    },
    {
      name: "Menu Count",
      key: "AccessibleMenuCount",
      selector: (row) => row.AccessibleMenuCount,
      cell: (row) => (
        <div
          className="Common_Link_Style"
          data-bs-toggle="modal"
          data-bs-target="#AccessibleMenu"
          onClick={() => handleMenuCountGrid(row)}
        >
          {row.AccessibleMenuCount}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Status",
      key: "InmateStatus",
      selector: (row) => row.InmateStatus,
      cell: (row) => (
        <div className="d-flex flex-wrap justify-content-center align-items-center h-100">
          <img
            title={row.InmateStatus === 1 ? "Active User" : "Inactive User"}
            src={row.InmateStatus === 1 ? activeIcon : inactiveIcon}
            alt={row.InmateStatus === 1 ? "Active User" : "Inactive User"}
            style={{ width: "20px", height: "20px" }} // Adjust icon size as needed inactiveIcon
          />
        </div>
      ),
      sortable: true,
      center: true,
    },
  ];

  //Popup Grid Column
  const accessMenuColumn = [
    {
      name: "S.No",
      cell: (row, index) => index + 1,
    },
    {
      name: "Menu Name",
      selector: (row) => row.MenuName,
    },
  ];

  //Popup

  // const [menuAccess, setMenuAcess] = useState({
  //   FacilityID: 0,
  //   InmateId: 0,
  // });

  // useEffect(() => {
  //   if (menuAccess.FacilityID && menuAccess.InmateId) {
  //     dispatch(
  //       logReportAction.InmateAccessibleMenuList({
  //         FacilityID: menuAccess.FacilityID,
  //         InmateId: menuAccess.InmateId,
  //       })
  //     );
  //   }
  // }, [dispatch, menuAccess.FacilityID, menuAccess.InmateId]);

  const handleMenuCountGrid = (row) => {
    // setMenuAcess((prev) => ({
    //   ...prev,
    //   FacilityID: row.facilityID,
    //   InmateId: row.InmateID,
    // }));
    dispatch(
      logReportAction.InmateAccessibleMenuList({
        FacilityID: row.facilityID,
        InmateId: row.InmateID,
      })
    );
  };
  const handleNavigateInmateInfoID = (row) => {
    dispatch(inmateAction?.setInmateCurrentTab("inmate-info-tab"));
    history.navigate("InmateList/Details", {
      state: { inmate: row, source: "logreport-inmate-access", showTransactionTab: false, },
    });
    dispatch(authActions?.updateCommonFacilityCode(row?.facilityID));
  };

  //sorting

  let isSorting = false; // to restrict the pagination issue
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    // setSorting(true);
    isSorting = true;
    const search = { ...InmateAccessMenus };
    const newSortOrder = search?.SortBy?.includes(column.key)
      ? search?.SortBy?.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortBy = `${column.key} ${newSortOrder}`;
    dispatch(logReportAction.setInmateMenu(search));
    dispatch(
      logReportAction.InmateAccessReport({
        ...InmateAccessMenus,
        SortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  //Pagination
  const handlePageChange = (value, name) => {
    if (name === "inmateAccessReportList") {
      if (isSorting) {
        isSorting = false;
        return;
      }
      const params = { ...InmateAccessMenuSearch, PageNo: value };
      dispatch(logReportAction.setInmateMenu(params));
      dispatch(logReportAction.InmateAccessReport(params));
    }
  };

  const handleRowPerPage = (value, name) => {
    if (name === "inmateAccessReportList") {
      const params = {
        ...InmateAccessMenuSearch,
        RowCountPerPage: value,
        PageNo: 1,
      };
      dispatch(logReportAction.setInmateMenu(params));
      dispatch(logReportAction.InmateAccessReport(params));
    }
  };

  //Export Excel
  useEffect(() => {
    if (
      inmateAccessReportFullList?.DataList?.length > 0 &&
      InmateAccessMenuSearch?.InmateMenuAccessReports.length > 0
    ) {
      const title = "InmateMenuReport ";
      const generateColumn = [
        "ID",
        "Last Name",
        "First Name",
        "POD",
        "Gender",
        "DOB",
        "Menu Count",
        "Status",
        "Menu Names",
      ];

      const excelData = inmateAccessReportFullList?.DataList?.map((obj, i) => ({
        ID: obj.InmateResidentID,
        LastName: obj.LastName,
        FirstName: obj.FirstName,
        Pod: obj.PodCode,
        Gender: obj.Gender,
        DOB: fDate(obj.DOB),
        MenuCount: obj.AccessibleMenuCount,
        InmateStatus: obj.InmateStatus === 1 ? "Current" : "",
        MenuNames: InmateAccessMenuSearch?.InmateMenuAccessReports.map(
          (item) => item.MenuName
        ) // Extract menu names
          .join(", "), // Join names with a comma
      }));

      // Generate the Excel file with the transformed data

      try {
        generateXlsx(excelData, generateColumn, title);
        dispatch(logReportAction.clearinmateAccessReportFullList());
      } catch (error) { }
    } else if (inmateAccessReportFullList?.DataList?.length > 0) {
      Popup({
        title: "Message",
        text: `Select any one of the Accessible Menu in the dropdown list`,
        icon: "info",
        confirmButtonText: "Ok",
      });
    }
  }, [inmateAccessReportFullList]);

  const handleExcel = () => {
    let updatedParams = {
      ...InmateAccessMenuSearch,
      PageNo: 1,
      RowCountPerPage: inmateAccessReportList?.TotalRecordCount,
      exportExcel: true,
    };

    dispatch(logReportAction.InmateAccessReport(updatedParams));
  };

  if (inmateAccessReportList?.loading) {
    return <CustomLoader />;
  }
  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };
  const renderSearch = () => {
    return (
      <form>
        <div className="row">
          <div className="col-sm-6 col-md-6">
            <div className="form-floating mb-3">
              <SelectInput
                name="facilityID"
                label="Facility Code"
                options={facilityDropDown}
                value={InmateAccessMenuSearch?.FacilityID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "FacilityID")
                }
                isMulti={false}
                isClearable={InmateAccessMenuSearch?.FacilityID ? true : false}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6">
            <div className="form-floating mb-3">
              {/* <SelectInput
                  name="Accessible Menu"
                  label="Accessible Menu"
                  options={inmateAccessMenuList}
                  value={InmateAccessMenuSearch?.InmateMenuAccessReports || []}
                  // value={[
                  //   { value: 9, label: "My Invites" },
                  //   { value: 4, label: "Documents" },
                  // ]}
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "Accessible Menu")
                  }
                  isMulti={true}
                  isClearable={true}
                  key={InmateAccessMenus.InmateMenuAccessReports} // Force re-render
                /> */}
              <SelectInput
                key={InmateAccessMenuSearch.FacilityID}
                name="Accessible Menu"
                label="Accessible Menu"
                options={inmateAccessMenuList}
                value={InmateAccessMenuSearch.InmateMenuAccessReports}
                // value={InmateAccessMenuSearch.InmateMenuAccessReports.map(
                //   (report) => report?.InmateMenuID
                // )}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "Accessible Menu")
                }
                isMulti={true}
                // isClearable={true}
                isClearable={
                  InmateAccessMenuSearch.InmateMenuAccessReports ? true : false
                }
                isDisabled={!InmateAccessMenuSearch.FacilityID}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateResidentID"
                label="Inmate ID"
                value={InmateAccessMenuSearch?.InmateResidentID}
                handleChange={(selectedOption) =>
                  handleChange(selectedOption, "InmateResidentID")
                }
                isMulti={false}
                isClearable={true}
                maxLength={18}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6">
            <div className="form-floating mb-3">
              <SelectInput
                name="InmateStatus"
                label="Inmate Status"
                options={podStatusOptions}
                value={InmateAccessMenuSearch?.InmateStatus}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "InmateStatus")
                }
                // isDisabled={IrrelevantSearch.FacilityID === 0 ? true : false}
                isMulti={false}
                isClearable={InmateAccessMenuSearch?.InmateStatus !== 1}
              />
            </div>
          </div>
        </div>

        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            className="me-2"
            label="Search"
            type="submit"
            status="primary"
            icon={"search"}
            onClick={handleSearch}
          />
          <Button
            className="me-2"
            label="Reset"
            type="button"
            icon={"fa-solid fa-rotate-right"}
            status="secondary"
            onClick={handleReset}
          />
        </div>
      </form>
    );
  };

  return (
    <div>
      <div className="card b-r-all  p-4 border border-dark-grey mt-3 me-3 w-100">
        {/* <div className="mb-2">
          <h2 className="form_title_uppercase text-color">
            Inmate Accessible Menus
          </h2>
        </div> */}
        <div className=" d-block d-md-none">
          <div
            className=" d-flex align-items-center justify-content-between"
            style={{ background: "transparent", cursor: "pointer" }}
            onClick={toggleInformation}
          >
            <h2 className="form_title_uppercase text-color">
              Inmate Accessible Menu Search
            </h2>
            <i
              id="itagInformation"
              className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
        </div>
        {/* Mobile only (Below md breakpoint) */}
        <div className="d-block d-md-none mt-2">
          {showSearchFields && renderSearch()}
        </div>

        {/* Web only (Desktop and above) */}
        <div className="mb-3 d-none d-md-block">
          <h2 className="form_title_uppercase text-color">
            Inmate Accessible Menu Search
          </h2>
        </div>
        {/* Web only (Desktop and above) */}
        <div className="d-none d-md-block">{renderSearch()}</div>
      </div>

      <div className="mt-5">
        {InmateAccessMenuSearch.FacilityID == 0 ? (
          <div className="text-center">
            <b className="table-no-data-text mt-5 fs-4 mb-5">
              Select any one of the Facility Code in the dropdown list
            </b>
          </div>
        ) : (
          <>
            {inmateAccessReportList?.DataList?.length > 0 && (
              <>
                <div className=" d-flex gap-3 align-items-center mb-2 ">
                  <div className="col-12 d-flex flex-wrap justify-content-between align-items-center resp-space">
                    <h2 className="form_title_uppercase text-color">
                      Inmate Accessible Menu LIST
                    </h2>

                    <div>
                      {/* Right-aligned Export Button */}
                      <div className="ms-auto d-flex flex-wrap gap-3 align-items-center">
                        {inmateAccessReportList?.DataList?.length > 0 && (
                          <ExcelExport handleExcelExport={handleExcel} />
                        )}
                      </div>
                    </div>
                  </div>
                  {/* Left-aligned Content */}
                </div>
                <div className="d-flex flex-wrap align-items-center gap-3 mt-2 mb-2">
                  <div className="d-flex  align-items-center">
                    <img
                      src={activeIcon}
                      alt="Active Icon"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <span className="ms-2">Inmate Current</span>
                  </div>
                  <div className="d-flex  align-items-center">
                    <img
                      src={inactiveIcon}
                      alt="Inactive Icon"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <span className="ms-2">Inmate Released</span>
                  </div>
                </div>
              </>
            )}

            {/* {invalidLogReportList?.DataList?.length > 0 && (
            <ExcelExport handleExcelExport={handleExcel} />
          )} */}

            {/* Table */}
            <Table
              columns={column}
              data={inmateAccessReportList?.DataList}
              pagination={true}
              onChangePage={(e) =>
                handlePageChange(e, "inmateAccessReportList")
              } // Call API when page changes
              onChangeRowsPerPage={(e) =>
                handleRowPerPage(e, "inmateAccessReportList")
              }
              totalRowCount={inmateAccessReportList?.TotalRecordCount}
              currentPage={InmateAccessMenuSearch?.PageNo}
              paginationPerPage={InmateAccessMenuSearch.RowCountPerPage}
              serverSideSort
              onSort={handleSort}
              sortColumn={InmateAccessMenuSearch?.SortBy?.split(" ")[0]}
              sortDirection={InmateAccessMenuSearch?.SortBy?.split(" ")[1]}
            />
          </>
        )}
        <CommonModal
          modalId="AccessibleMenu"
          title="ACCESSIBLE MENUS DETAILS"
          bodyContent={
            <Table
              title={""}
              columns={accessMenuColumn}
              loader={inmateAccessibleMenuList?.loading}
              data={inmateAccessibleMenuList?.data || []} // Fallback to an empty array
              pagination={false}
              onChangePage={(e) => handlePageChange(e, "MenuAccess")} // Call API when page changes
              onChangeRowsPerPage={(e) => handleRowPerPage(e, "MenuAccess")} // Handle rows per page  change
              totalRowCount={inmateAccessibleMenuList?.data?.length}
            />
          }
          footerContent={
            <button
              className="btn button-primary"
              data-bs-dismiss="modal"
            // onClick={handleCloseModal}
            >
              Close
            </button>
          }
        />
      </div>
    </div>
  );
}

export default React.memo(InmateAccessableMenus);
